import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
  } else {
    next('home')
  }
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (store.getters.getProfile.enable_2fa) {
      if (localStorage.getItem('enable_2fa')) {
        next()
      } else {
        next('/otp')
      }
    } else {
      next()
    }
  } else {
    next('/')
  }
}

const ifAuthenticatedValitationUser = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  localStorage.setItem('pathValidationUser', to.path)
  next('/')
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../components/Login.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/signup_apartment',
    name: 'signup_apartment',
    component: () => import('../views/signup_apartment.vue')
  },
  {
    path: '/validavivienda/:token',
    name: 'valida_vivienda',
    component: () => import('../views/admin/valida_vivienda.vue')
  },
  {
    path: '/fraccionamientos',
    name: 'fraccionamientos',
    component: () => import('../views/super_admin/housing_units.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/managers',
    name: 'managers',
    component: () => import('../views/super_admin/managers.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/historical_superadmin',
    name: 'historical_superadmin',
    component: () => import('../views/super_admin/historical_superadmin.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/casas',
    name: 'casas',
    component: () => import('../views/admin/houses.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/notices',
    name: 'notices',
    component: () => import('../views/admin/notices.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/parcel',
    name: 'parcel',
    component: () => import('../views/common/parcel.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/guest_management',
    name: 'guest_management',
    component: () => import('../views/admin/guest_management.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/water_service',
    name: 'water_service',
    component: () => import('../views/common/water_service.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/directory',
    name: 'directory',
    component: () => import('../views/admin/directory.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/account_statements',
    name: 'account_statements',
    component: () => import('../views/admin/account_statements.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/account_statements_main_resident',
    name: 'account_statements_main_resident',
    component: () => import('../views/main_resident/account_statements_main_resident.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import('../views/main_resident/reports'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/main_residents',
    name: 'main_residents',
    component: () => import('../views/admin/main_residents.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/pets',
    name: 'pets',
    component: () => import('../views/admin/pets.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/main_residents_2',
    name: 'main_residents_2',
    component: () => import('../views/admin/main_residents_2'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/guards',
    name: 'guards',
    component: () => import('../views/admin/guards.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/guardhouses',
    name: 'guardhouses',
    component: () => import('../views/admin/guard_houses.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/settings.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/invitation',
    name: 'invitation',
    component: () => import('../views/admin/invitation.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/signup_apartment_success',
    name: 'signup_apartment_success',
    component: () => import('../views/common/signUpApartmentSuccess.vue')
  },
  {
    path: '/preregistration/:token',
    name: 'preregistration',
    component: () => import('../views/common/preregistration.vue')
  },
  {
    path: '/data_correction/:code_correction',
    name: 'data_correction',
    component: () => import('../views/common/data_correction.vue')
  },
  {
    path: '/self_validate/:token',
    name: 'self_validate',
    component: () => import('../views/common/self_validate.vue')
  },
  {
    path: '/booth_registration/:token',
    name: 'booth_registration',
    component: () => import('../views/guard/booth_registration.vue')
  },
  {
    path: '/terms_conditions',
    name: 'terms_conditions',
    component: () => import('../views/public/terms_conditions')
  },
  {
    path: '/notice_privacy',
    name: 'notice_privacy',
    component: () => import('../views/public/notice_privacy')
  },
  {
    path: '/validationuser/:token',
    name: 'validationuser',
    component: () => import('../views/common/validationuser.vue'),
    beforeEnter: ifAuthenticatedValitationUser
  },
  {
    path: '/validate_guest/:code_correction',
    name: 'validate_guest',
    component: () => import('../views/common/validate_guest.vue'),
    beforeEnter: ifAuthenticatedValitationUser
  },
  {
    path: '/user_confirmed_successfully',
    name: 'user_confirmed_successfully',
    component: () => import('../views/common/user_confirmed_successfully.vue')
  },
  {
    path: '/user_removed_successfully',
    name: 'user_removed_successfully',
    component: () => import('../views/common/user_removed_successfully.vue')
  },
  {
    path: '/user_invalidate_successfully',
    name: 'user_invalidate_successfully',
    component: () => import('../views/common/user_invalidate_successfully.vue')
  },
  {
    path: '/reset_password',
    name: 'reset_password',
    component: () => import('../views/common/reset_password.vue')
  },
  {
    path: '/otp',
    name: 'otp',
    component: () => import('../views/common/otp.vue')
  },
  {
    path: '/reset_password_done',
    name: 'reset_password_done',
    component: () => import('../views/common/reset_password_done.vue')
  },
  {
    path: '/register/success',
    name: 'register_success',
    component: () => import('../views/common/register_success.vue')
  },
  {
    path: '/self_validate_data/success',
    name: 'register_success',
    component: () => import('../views/common/self_validate_success.vue')
  },
  {
    path: '/qrcode/:qrcode',
    name: 'qr_code',
    component: () => import('../views/public/qr_code.vue')
  },
  {
    path: '/request_join_house/:pk',
    name: 'request_join_house',
    component: () => import('../views/public/request_join_house.vue')
  },
  {
    path: '/residents',
    name: 'residents',
    component: () => import('../views/main_resident/residents.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/workers',
    name: 'workers',
    component: () => import('../views/main_resident/workers.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/workers_admin',
    name: 'workers_admin',
    component: () => import('../views/admin/workers_admin.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/contractors_admin',
    name: 'contractors_admin',
    component: () => import('../views/admin/contractors_admin.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/print',
    name: 'print',
    component: () => import('../views/admin/print'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/checkin_checkout',
    name: 'checkin_checkout',
    component: () => import('../views/guard/checkin_checkout.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/checkin_checkout_qr/:tab',
    name: 'checkin_checkout_qr',
    component: () => import('../views/guard/checkin_checkout_qr.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/checkin_checkout_qr2/:tab',
    name: 'checkin_checkout_qr2',
    component: () => import('../views/guard/checkin_checkout_qr2.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/access_without_code',
    name: 'access_without_code',
    component: () => import('../views/guard/access_without_code.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/access_without_code_cam',
    name: 'access_without_code_cam',
    component: () => import('../views/guard/access_without_code_cam.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/historical',
    name: 'historical',
    component: () => import('../views/common/historical.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/historical_no_code',
    name: 'historical_no_code',
    component: () => import('../views/common/historical_no_code.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/current_invitations',
    name: 'current_invitations',
    component: () => import('../views/guard/current_invitations.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/events',
    name: 'events',
    component: () => import('../views/guard/events.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/delivery',
    name: 'delivery',
    component: () => import('../views/guard/delivery.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/offline',
    name: 'offline',
    component: () => import('../views/common/offline.vue')
  },
  {
    path: '/ayuda',
    name: 'ayuda',
    component: () => import('../views/common/ayuda.vue'),
    beforeEnter: ifAuthenticated
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
